import { z } from 'zod'

import { userModel } from '@/common/models/user'

export const userSubject = z.tuple([
  z.union([
    z.literal('create'),
    z.literal('edit'),
    z.literal('inactivate'),
    z.literal('reactivate'),
    z.literal('reset'),
    z.literal('delete'),
  ]),
  z.union([z.literal('User'), userModel]),
])

export type UserSubject = z.infer<typeof userSubject>
